import { Badge, Logo, NetworkBadge } from "@custos/ui";
import type { ReactNode } from "react";
import { useConfig } from "../lib/queries";

/** Signed-out admin screens: a frosted card floating over the pastel sky (D88). */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  const config = useConfig();
  return (
    <div className="flex min-h-dvh flex-col items-center px-4 pt-5 pb-10">
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center justify-between gap-3 sm:mb-12">
          <span className="flex items-center gap-2">
            <Logo />
            <Badge tone="primary">Admin</Badge>
          </span>
          {config.data && <NetworkBadge label={config.data.badge} />}
        </div>
        <div className="mb-6 px-1 text-center">
          <h1 className="font-heading text-[32px] leading-tight font-semibold tracking-[-0.03em] text-fg">
            {title}
          </h1>
          {subtitle && <p className="mt-2 text-base text-muted">{subtitle}</p>}
        </div>
        <div className="glass animate-rise rounded-[32px] p-5 sm:p-7">{children}</div>
      </div>
    </div>
  );
}
